import { useState } from "react";
import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminResetPassword() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (pwd.length < 8) { setError("La contraseña debe tener al menos 8 caracteres."); return; }
    if (pwd !== pwd2) { setError("Las dos contraseñas no coinciden."); return; }
    setBusy(true);
    setError("");
    try {
      await api.post("/admin/reset-password", { token, new_password: pwd });
      setDone(true);
    } catch (e) {
      const d = e?.response?.data?.detail;
      setError(typeof d === "string" ? d : "No se pudo cambiar la contraseña. Pide un enlace nuevo.");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="card max-w-md w-full" data-testid="reset-password-card">
        <Lock className="gold" size={24}/>
        <h1 className="font-serif text-3xl font-light mt-4">Contraseña nueva</h1>
        {done ? (
          <>
            <p className="text-sm mt-3" data-testid="reset-password-success">Listo. Tu contraseña se ha cambiado y se han cerrado todas las sesiones abiertas.</p>
            <Link to="/admin" className="btn-primary mt-6 w-full inline-block text-center" data-testid="reset-go-login">Entrar al panel</Link>
          </>
        ) : !token ? (
          <p className="text-sm mt-3 text-red-700" data-testid="reset-password-error">Enlace no válido. Pide uno nuevo desde «¿Has olvidado tu contraseña?».</p>
        ) : (
          <>
            <p className="text-[#6B6B6B] mt-2 text-sm">Mínimo 8 caracteres. El enlace solo sirve una vez.</p>
            <input type="password" className="field mt-6" placeholder="Contraseña nueva" autoComplete="new-password"
              value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-password-new" />
            <input type="password" className="field mt-3" placeholder="Repite la contraseña" autoComplete="new-password"
              value={pwd2} onChange={(e) => setPwd2(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} data-testid="reset-password-confirm" />
            {error && <p className="text-xs text-red-700 mt-3" data-testid="reset-password-error">{error}</p>}
            <button className="btn-primary mt-4 w-full" onClick={submit} disabled={busy} data-testid="reset-password-submit">
              {busy ? "Guardando…" : "Guardar contraseña"}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
